import { Box, Button } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import {
    Collections,
    RaceConfiguration,
    StatusRace,
    StatusRaceControl,
    StatusRound,
} from "api";
import { useSnackbar } from "notistack";
import React, { useContext } from "react";
import { useFirestore } from "react-redux-firebase";
import { LoggedUserContext } from "ui/componentes";

interface StartRoundButtonProps {
    roundId: string;
    championshipId: string;
    raceConfigurations: RaceConfiguration[];
}

const StartRoundButton: React.FC<StartRoundButtonProps> = ({
    raceConfigurations,
    roundId,
    championshipId,
}) => {
    const firestore = useFirestore();
    const loggedUser = useContext(LoggedUserContext);
    const { enqueueSnackbar } = useSnackbar();

    const startRound = async () => {
        const races = raceConfigurations.map((config, index) => {
            return {
                roundId,
                championshipId,
                raceNumber: index + 1,
                createdBy: `${loggedUser.displayName} (${loggedUser.privateInfo.email})`,
                createdAt: firestore.FieldValue.serverTimestamp(),
                status: StatusRace.IN_PROGRESS,
            };
        });

        const racesInserts: any = races.map((race) => {
            return firestore
                .collection(Collections.RACES)
                .add(race)
                .then((docRef) => {
                    return firestore.collection(Collections.RACES_CONTROL).add({
                        roundId,
                        championshipId,
                        raceId: docRef.id,
                        raceNumber: race.raceNumber,
                        createdBy: `${loggedUser.displayName} (${loggedUser.privateInfo.email})`,
                        createdAt: firestore.FieldValue.serverTimestamp(),
                        status: StatusRaceControl.IN_PROGRESS,
                    });
                });
        });

        racesInserts.push(
            firestore
                .collection(Collections.ROUNDS)
                .doc(roundId)
                .update({ status: StatusRound.IN_PROGRESS })
        );

        await Promise.all(racesInserts)
            .then(() => {
                enqueueSnackbar("Etapa iniciada!", { variant: "success" });
            })
            .catch(() => {
                enqueueSnackbar("Não foi possível iniciar a etapa!", {
                    variant: "error",
                });
            });
    };

    return (
        <Box
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Button
                onClick={startRound}
                style={{
                    backgroundColor: green[500],
                    color: "#FFFFFF",
                    width: "300px",
                    height: "85px",
                }}
                startIcon={
                    <PlayCircleFilledWhiteIcon style={{ fontSize: 40 }} />
                }
            >
                Iniciar etapa
            </Button>
        </Box>
    );
};

export { StartRoundButton };
